import React from "react";
import { LoadingOverlay } from "@kernel/react-ui-kit";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { LayoutRoute } from "../layout/LayoutRoute";
import { StatsLayoutRoute } from "../layout/StatsLayoutRoute";
import { useMainBloc } from "@modules";

export function Main() {
  const main = useMainBloc();
  return (
    <>
      <LoadingOverlay active={main.loader.head()!.loading} logo={main.logo}>
        <h6 className="my-4">{main.loader.head()!.title}</h6>
      </LoadingOverlay>
      {main.loaded && (
        <BrowserRouter>
          <Routes>
            <Route
              path="/stats/repository"
              element={
                <StatsLayoutRoute
                  logo={main.logo}
                  title={main.title}
                  module="stats-repository"
                  customer={main.customer}
                  footerEnabled={main.footerEnabled}
                  version={main.version}
                />
              }
            />
            <Route
              path="/stats/:type/:name?"
              element={
                <StatsLayoutRoute
                  logo={main.logo}
                  title={main.title}
                  module="stats"
                  customer={main.customer}
                  footerEnabled={main.footerEnabled}
                  version={main.version}
                />
              }
            />
            <Route
              path="/trialsnet"
              element={
                <LayoutRoute
                  logo={main.logo}
                  title="TrialsNet"
                  module="trialsnet"
                  customer={main.customer}
                  footerEnabled={main.footerEnabled}
                  version={main.version}
                />
              }
            />
            <Route
              path="/xrel"
              element={
                <LayoutRoute
                  logo={main.logo}
                  title="XREL"
                  module="xrel"
                  customer={main.customer}
                  footerEnabled={main.footerEnabled}
                  version={main.version}
                />
              }
            />
            <Route
              path="/:roomName?"
              element={
                <LayoutRoute
                  logo={main.logo}
                  title={main.title}
                  module="home"
                  customer={main.customer}
                  footerEnabled={main.footerEnabled}
                  version={main.version}
                />
              }
            />
          </Routes>
        </BrowserRouter>
      )}
    </>
  );
}
